//React
import React from "react";
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

//Add
import moment from 'moment';

//Img
import imgVisa from '../img/credit/visa.png';
import imgMaster from '../img/credit/master.png';
import imgJcb from '../img/credit/jcb.png';
//Icon

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
//Dialog
import DialogConfirm from './DialogConfirm';
//JSON
var chargePlanItem = require('../data/chargePlanItem');


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      days: '',
      price: '',
      noProofPerson: false,
    }
	}

  _select(days, price) {
    if (this.props.my.proof.person !== 1 && this.props.my.proof.credit !== 1) {
      this.setState({noProofPerson: true });
    }
    else {
      this.setState({days: days, price: price}, () => document.credit_form.submit() );

    }
  }

  render() {
    let startDate = moment.unix(this.props.my.setting.chargeStart);
    let endDate =  moment.unix(this.props.my.setting.chargeEnd);
    let nowDate =  moment();

    return (
      <div>
        <div style={{padding:'10px'}}>
          <h2 align='center'>クレジット決済について</h2>

          <div style={{padding:'10px'}}>
            <div style={{color:'#666'}}>
              決済は最高レベルのセキュリティーで個人情報を管理しているテレコムクレジットの決済ページで行います。<br/>
              弊社にカード番号は送られず、保存もされません。
            </div>
          </div>

          <div style={{padding:'10px'}}>
            <Grid container justifyContent="center" alignItems="center" spacing={1}>
              <Grid item>
                <img
                  src={ imgVisa }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgMaster }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgJcb }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <div style={{
                  display:'flex',
                  alignItems:'center',
                  background:'#FFF',
                  fontSize:'0.8em',
                  borderRadius:'3px',
                  border:'solid 1px #CCC',
                  height:'40px'
                }}>
                  その他各種<br/>クレジットカード
                </div>
              </Grid>
            </Grid>

            <div style={{color:'#666'}}>
              Visa、Master、JCBなど主要カード会社のクレジット(デビット)カードがご利用いただけます。
              決済後すぐに有料サービスがご利用いただけます。
            </div>
          </div>




          <div align='center'>
            <Button
              color="primary"
              variant={ "outlined" }
              onClick={ () => this.props.helpOpen('id',317) }
            >
              <span style={{fontSize:'1em'}}>
                クレジット決済は返金保証付き<br/ >
                適応条件についてはコチラ
              </span>
            </Button>


          </div>
        </div>



        <div style={{padding:'10px'}}>
          <h2 align='center'>プランを選択してください</h2>
          {
            (nowDate.isBetween(startDate , endDate) === true) && (
              <div style={{padding:'10px'}}>お客様のアカウントは有料サービス中の為、有料サービスの終了日はプランの日数分延長されます。</div>
            )
          }

          <div style={{maxWidth:'400px', margin:'auto'}}>
            {
              chargePlanItem.map( (value, index) => {
                let borderColor;
                let textColor;
                let iconType;
                if (index === 0) {
                  borderColor = '#FFE7C2';
                  textColor = '#FF9900';
                  iconType = 'orange_icon';
                }
                else if (index === 1) {
                  borderColor = '#A6BDD5';
                  textColor = '#0D58A6';
                  iconType = 'blue_icon';
                }
                else if (index === 2) {
                  borderColor = '#E7B0D0';
                  textColor = '#CB0077';
                  iconType = 'red_icon';
                }

                let startDate = moment.unix(this.props.my.setting.chargeStart);
                let endDate =  moment.unix(this.props.my.setting.chargeEnd);
                let nowDate =  moment();
                let newEndDateComp;

                if (nowDate.isBetween(startDate , endDate )) {
                  newEndDateComp = (
                      <div style={{marginTop:'5px'}}>
                        <div style={{fontSize:'0.9em', color:'#666'}}>有料サービス</div>
                        <div style={{fontSize:'1.1em', color:'#333'}}>{ endDate.add(value.days, 'days').format('YYYY年MM月DD日') }まで</div>
                      </div>
                  )
                }
                else {
                  newEndDateComp = (
                    <div style={{marginTop:'5px'}}>
                      <div style={{fontSize:'0.9em', color:'#666'}}>有料サービス</div>
                      <div style={{fontSize:'1.1em', color:'#333'}}>{ nowDate.add(value.days, 'days').format('YYYY年MM月DD日') }まで</div>
                    </div>
                  )
                }

                return (
                  <div key={index}>
                    <Box className='button_chargePlan round12' boxShadow={3}
                      style={{
                        color: '#333',
                        borderTop: 'solid 6px ' + borderColor,
                        margin: '15px',
                        cursor: 'pointer',
                      }}
                      onClick={ () => this._select(value.days, value.price) }
                    >
                      <div style={{padding:'15px'}}>
                        <div
                          style={{
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'space-between',
                          }}
                        >
                          <div style={{fontSize:'1.4em', fontWeight:500, color:textColor}}>{ value.ja }</div>
                          <div>
                            <ArrowForwardIosIcon size='24' style={{margin:'5px', color:textColor}} />
                          </div>
                        </div>

                        <div>
                          <div
                            style={{
                              display:'flex',
                              flexDirection:'row',
                              alignItems:'center',
                              justifyContent:'space-between',
                            }}
                          >
                            <div>
                              <span style={{fontSize:'1.8em', fontWeight:'bold', color:textColor}}>¥{ value.price }</span>
                              <span style={{fontSize:'1em', color:textColor}}>(税込)</span>
                            </div>

                            {
                              (value.discount > 0) && (
                                <div><span className={iconType}>¥{value.discount}お得</span></div>
                              )
                            }
                          </div>
                          {
                            (value.convert > 0) && (
                              <div>30日換算で¥{ value.convert }</div>
                            )
                          }

                          {
                            newEndDateComp
                          }
                        </div>


                      </div>
                    </Box>
                  </div>
                )
              })
            }
          </div>
        </div>


        <form
          name='credit_form'
          method='POST'
          action='https://secure.telecomcredit.co.jp/inetcredit/secure/order.pl'
        >
          <input name='clientip' type='hidden' value='74021' />
          <input name="sendid" type="hidden" value={ this.props.auth.ui } />
          <input name='money' type='hidden' value={ this.state.price } />
          <input name='option' type='hidden' value={ this.state.days } />
          { (this.props.my.setting.creditcardEmail) && <input name="usrmail" type="hidden" value={ this.props.my.setting.creditcardEmail } /> }
          { (this.props.my.setting.creditcardTel) && <input name="usrtel" type="hidden" value={ this.props.my.setting.creditcardTel } /> }
          { (this.props.my.setting.creditcardName) && <input name="usrname" type="hidden" value={ this.props.my.setting.creditcardName } /> }
          <input name="redirect_url" type="hidden" value="https://www.partner-s.net/pwa/setting/charged/" />
        </form>

        <div style={{padding:'5px'}}>
          <div style={{padding:'10px',fontSize:'0.9em',color:'#666'}}>
            ※ 返金保証には適応条件があります。適応条件と一致している場合、サポートにご連絡いただけましたら、ご決済金額のご返金手続きを行わせていただいております。
          </div>

          <div style={{padding:'10px',fontSize:'0.9em',color:'#666'}}>
            ※ クレジットカードによる初回決済後は、自動更新がON設定となります。<br />
            有料サービスの自動更新がONに設定されている場合、有料サービスの利用期間の最終日（23時）に、自動的に有料サービスが更新され、30日プラン￥2980の課金が発生いたします。
          </div>



          <div style={{padding:'10px',fontSize:'0.9em',color:'#666'}}>
            ※ 提供サービスの性質上、クーリングオフの適応はありません。<br/>
            また有料サービスの期間中に退会された場合も日割り計算による料金の払い戻しはありません。
          </div>
        </div>

        <DialogConfirm
          open={ this.state.noProofPerson }
          title={'本人証明が未提出'}
          content={(
            <div>
              <h2 align='center'>有料サービスのお申し込みには<br/>本人証明が必要です</h2>
              <div align='center' style={{padding:'10px'}}>
                <Link to='/my/proof/person'>
                  <Button
                    variant="contained"
                    color='primary'
                  >
                    本人証明を申請する
                  </Button>
                </Link>
              </div>
            </div>
          )}
          close={ () => this.setState({noProofPerson: false}) }
        />
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    auth: state.auth,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
